import api from "./Api";

class AtendimentoOrdemServicoService {
  GetAtendimentoOrdemServico(payload) {
    return api
      .get("/v1/atendimentoOrdemServico/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostAtendimentoOrdemServico(payload) {
    return api
      .post("/v1/atendimentoOrdemServico/", payload)
      .then((response) => {
        return response.data;
      });
  }

  PutAtendimentoOrdemServico(payload) {
    return api.put("/v1/atendimentoOrdemServico/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteAtendimentoOrdemServico(payload) {
    return api
      .delete("/v1/atendimentoOrdemServico/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetAtendimentoOrdemServicoOData(payload) {
    return api
      .get("/OData/AtendimentoOrdemServico" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new AtendimentoOrdemServicoService();
